import React, { FC } from 'react';
import Box from '@mui/material/Box';
import translate from '@translate';
import { colors, sizes } from 'src/themes/default';
import FormBlock from 'src/components/FormBlock';
import TextField from 'src/components/TextField';
import { ProductEanType } from 'src/types/product';
import { FormErrorsType } from '../../types/global';
import NewEanBlock from './NewEanBlock';
import EansTable from './EansTable';

export interface EansTabPropsType {
    data?: ProductEanType[];
    onChange: (value: ProductEanType[]) => void;
    disableEdit?: boolean;
    editErrors: FormErrorsType;
    /** Přidat EAN smí každý s PRODUCT.UPDATE; soft-delete (deaktivace) / aktivace jen správce nebo odemčený produkt. */
    canDeactivateRemove?: boolean;
    productSku?: string;
    eanLockedByWms?: boolean | number;
}

const EansTab: FC<EansTabPropsType> = (props) => {
    const locked = !!props.eanLockedByWms;

    return (
        <>
            <FormBlock sx={{ marginBottom: sizes.blocks_top_MG }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'flex-start',
                        gap: 2,
                    }}
                >
                    <Box sx={{ flex: '0 0 25%', maxWidth: '25%', minWidth: 0 }}>
                        <TextField
                            value={locked ? translate('utils.boolCodes.yes') : translate('utils.boolCodes.no')}
                            name="EAN_LOCKED_BY_DCIX"
                            label={translate('productDetail.eanLockedByDcix')}
                            fullWidth
                            disabled
                            inputProps={{
                                style: { color: locked ? colors.accent_O : colors.alert_O },
                            }}
                        />
                    </Box>
                    <NewEanBlock
                        data={props.data || []}
                        onChange={props.onChange}
                        disableEdit={props.disableEdit}
                        editErrors={props.editErrors}
                    />
                </Box>
            </FormBlock>
            <EansTable
                data={props.data}
                onChange={props.onChange}
                disableEdit={props.disableEdit}
                canDeactivateRemove={props.canDeactivateRemove}
                productSku={props.productSku}
            />
        </>
    );
};

export default EansTab;
